import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  makeStyles,
  createStyles,
  Theme,
  TextField,
  Typography,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { IUser } from "../../core/redux/dataMap/user";
import { Actions } from "../../core/redux/ducks/user";
import { useFormik } from "formik";
import { ChangePassword } from "./ChangePassword";
import { DropzoneArea } from "material-ui-dropzone";
import { CustomAvatar } from "../../components/CustomAvatar";
import useLanguage from "../../hooks/useLanguage";

interface IProfileProps {
  isOpen: boolean;
  closeModal(): void;
  user: IUser;
}

export const Profile: React.FC<IProfileProps> = ({
  isOpen,
  closeModal,
  user,
}) => {
  const [pageState, setPageState] = useState("");
  const [photo, setPhoto] = useState();
  const { language } = useLanguage();
  const { translate } = language;
  const classes = useStyles();
  const dispatch = useDispatch();
  const changeProfile = (profile: {
    first_name: string;
    last_name: string;
    image?: File;
  }) => Actions.changeProfile(dispatch, profile);

  const formik = useFormik({
    initialValues: {
      first_name: user?.firstName || "",
      last_name: user?.lastName || "",
    },
    onSubmit: (values) => {
      if (pageState === "image" && photo) {
        //@ts-ignore
        if (photo !== undefined) changeProfile({ ...values, image: photo[0] });
      } else {
        changeProfile(values);
      }
      handleCloseModal();
    },
    enableReinitialize: true,
    // validationSchema,
  });

  const handleCloseModal = () => {
    setPageState("");
    closeModal();
  };

  const handleChange = (file) => {
    setPhoto(file);
  };

  return (
    <div>
      <Dialog open={isOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">
        <DialogTitle>
          <Typography variant="h5" component="div">
            {translate.user_header}
          </Typography>
        </DialogTitle>
        {pageState === "password" ? (
          <ChangePassword closeModal={handleCloseModal} />
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <DialogContent>
              <Grid container direction="column" spacing={1}>
                <Grid item md={12}>
                  <Grid
                    container
                    direction="row"
                    spacing={1}
                    className={classes.userPic}
                  >
                    <Grid item md={6}>
                      <CustomAvatar user={user} size="lg" />
                    </Grid>
                    <Grid item md={6}>
                      {pageState === "image" ? (
                        <DropzoneArea
                          onChange={handleChange}
                          filesLimit={1}
                          showAlerts={false}
                        />
                      ) : (
                        <Button
                          color="primary"
                          onClick={() => setPageState("image")}
                          variant="outlined"
                        >
                          {translate.update_button}
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item className={classes.userName}>
                  <Grid container direction="row" spacing={1}>
                    <Grid item md={6}>
                      {translate.first_name}
                    </Grid>
                    <Grid item md={6}>
                      {translate.surname}
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={1}>
                    <Grid item md={6}>
                      <TextField
                        value={formik.values.first_name}
                        onChange={formik.handleChange}
                        id="first_name"
                        error={!!formik.errors.first_name}
                        helperText={formik.errors.first_name}
                        fullWidth
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        value={formik.values.last_name}
                        onChange={formik.handleChange}
                        id="last_name"
                        error={!!formik.errors.last_name}
                        helperText={formik.errors.last_name}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={12}>
                  <Grid container direction="column" spacing={1}>
                    <Grid item md={12}>
                      Email
                    </Grid>
                    <Grid item md={12}>
                      <Typography className={classes.email}>
                        {user?.email}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={12}>
                  <Grid container direction="column" spacing={1}>
                    <Grid item md={12}>
                      {translate.password}
                    </Grid>
                    <Grid item md={12}>
                      <Button
                        color="primary"
                        onClick={() => setPageState("password")}
                        variant="outlined"
                      >
                        {translate.update_button}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button color="secondary" onClick={handleCloseModal}>
                {translate.cancel}
              </Button>
              <Button color="primary" type="submit">
                {translate.update_button}
              </Button>
            </DialogActions>
          </form>
        )}
      </Dialog>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    userIcon: {
      fontSize: "55pt",
      fill: "#ccc",
    },
    userPic: {
      alignItems: "center",
    },
    userName: {
      width: "100%",
      margin: "20px 0",
    },
    email: {
      color: "#c4c4c4",
    },
  })
);
